import { readCustomerSourceHeadersFromStorage } from '@/libs/userSource/customerSourceStorage';
import { parseUserSourceHeaders } from '@/libs/userSource/parseUserSourceHeaders';
import { authApi } from '@/queries/auth/auth.api';

import { objectToQueryParams } from '../../utils/parsing.utils';

export type ExternalAuthProvider = 'google' | 'facebook' | 'apple';

const resolveStartAuth = (provider: ExternalAuthProvider) => {
  switch (provider) {
    case 'facebook':
      return authApi.registerWithFacebook;
    case 'apple':
      return authApi.registerWithApple;
    case 'google':
    default:
      return authApi.registerWithGoogle;
  }
};

export const externalAuth = async (
  provider: ExternalAuthProvider,
  fingerprintRequestId: string,
) => {
  try {
    const storedCustomerSourceHeaders = readCustomerSourceHeadersFromStorage();
    const parsedCustomerSourceHeaders = Object.keys(storedCustomerSourceHeaders).length
      ? storedCustomerSourceHeaders
      : parseUserSourceHeaders(window.location.href);

    // const sessionId = await getSeonSessionId();

    // static headers
    const staticHeaders: Record<string, string | undefined> = {
      'x-fingerprint-request-id': fingerprintRequestId,
      // 'x-anti-fraud-session-id': sessionId,
    };

    const queryString = objectToQueryParams({
      ...parsedCustomerSourceHeaders,
      ...staticHeaders,
    });

    const startAuth = resolveStartAuth(provider);

    if (queryString) {
      await startAuth(queryString);
      return;
    }

    await startAuth();
  } catch (err) {
    console.error(`externalAuth(${provider}) error`, err);
  }
};
